module.exports = __webpack_public_path__ + "img/2022-11-11_11-45-16.0f0d9d7d.jpg";